import { call, patch } from "@/services/api";

export type CrewPerson = { id: number; first_name: string; last_worked_on: string | null; permanent: boolean };

export const fetchCrew = (warehouseId: number) => call<{ crew: CrewPerson[] }>(`/api/v1/crew?warehouse_id=${warehouseId}`);
// Permanent at one warehouse, as his FIX lists them per warehouse.
export const setPermanent = (id: number, permanent: boolean, warehouseId: number) =>
  patch<{ id: number; permanent: boolean; warehouse_id: number }>(`/api/v1/crew/${id}`, { permanent, warehouse_id: warehouseId });
